import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import Typography from "@limitless/modern/data-display/typography/Typography";
import Button from "@limitless/modern/inputs/button/Button";
import { useNavigation } from "@limitless/portal";

const useStyles = makeStyles({
    headerText: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 4
    },
    text: {
        marginLeft: "3px"
    }
});

const DashboardHeader = ({ firstName }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { navigate } = useNavigation();

    const greeting = React.useMemo(() => {
        const hours = new Date().getHours();

        return hours < 12 ? t("Good morning") : hours < 18 ? t("Good afternoon") : t("Good evening");
    }, []);

    const handleNavigateToProfile = () => {
        navigate("/settings/profile");
    };

    return (
        <Grid container direction="row" justifyContent="space-between" sx={{ padding: 0 }} spacing={0}>
            <Grid item>
                <Grid className={classes.headerText}>
                    <Typography color={theme => theme.palette.text.primary} variant="h6">
                        {greeting}
                        {firstName && ",  "}
                    </Typography>
                    <Typography color={theme => theme.palette.text.primary} variant="h6" className={classes.text}>
                        {firstName ?? ""}
                    </Typography>
                </Grid>
                <Typography color={theme => theme.palette.text.secondary} variant="body2">
                    {t("Here's an overview of your performance")}{" "}
                </Typography>
            </Grid>
            <Grid item>
                <Button variant="outlined" size="medium" onClick={handleNavigateToProfile}>
                    {t("Edit Profile")}
                </Button>
            </Grid>
        </Grid>
    );
};
DashboardHeader.propTypes = {
    firstName: PropTypes.string
};
export default DashboardHeader;
